import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="email-confirmation"
export default class extends Controller {
  static targets = ["continue"];

  #interval;

  continueTargetConnected() {
    this.#startPolling();
  }

  continueTargetDisconnected() {
    this.#stopPolling();
  }

  #startPolling() {
    this.#interval = setInterval(() => {
      fetch("/onboarding/email-confirmation.json")
        .then((response) => response.ok && response.json())
        .then(({ email_confirmed }) => {
          if (email_confirmed) {
            this.continueTarget.click();
          }
        });
    }, 5000);
  }

  #stopPolling() {
    if (this.#interval) {
      clearInterval(this.#interval);
    }
  }
}
